<script>
/* eslint-disable no-console */
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from "@vue-bootstrap-components/vue-bootstrap-autocomplete";
import { toast, variants } from "@/helpers/toaster";
import ErrorAlert from "@/components/errorAlert";
import ConfirmationModal from "@/components/confirmationModal";

export default {
  page: {
    title: "Ariba",
  },
  components: {
    PageHeader,
    Layout,
    VueBootstrapAutocomplete,
    ErrorAlert,
    ConfirmationModal,
  },
  props: {},
  data() {
    return {
      title: "Ariba",
      activeTab: "sessions",
      currentPage: 1,
      perPage: 15,
      sortBy: "created_at",
      sortDesc: true,
      packageTypeMappingFields: [
        {
          key: "our_package_type",
          label: "Merna jedinica (BIGZ)",
          sortable: false,
        },
        {
          key: "ariba_package_type",
          label: "Merna jedinica (Ariba)",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      sessionFields: [
        { key: "id", label: "ID", sortable: false },
        { key: "admin.company_name", label: "Firma", sortable: false },
        { key: "created_at", label: "Kreirano", sortable: false },
        { key: "statusLabel", label: "Status", sortable: false },
        {
          key: "actions",
          label: "",
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      orderFields: [
        { key: "id", label: "ID", sortable: false },
        { key: "admin.company_name", label: "Firma", sortable: false },
        { key: "order_id", label: "Broj porudžbine", sortable: false },
        { key: "connection", label: "Nalog (ANID)", sortable: false },
        { key: "order_date", label: "Datum porudžbine", sortable: false },
        { key: "total_amount", label: "Ukupan iznos", sortable: false },
        {
          key: "actions",
          label: "",
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      anids: [],
      anidFields: [
        { key: "admin.company_name", label: "Firma", sortable: false },
        { key: "anid", label: "ANID", sortable: false },
        { key: "label", label: "Naziv", sortable: false },
        { key: "type", label: "Tip", sortable: false },
        { key: "secret", label: "Lozinka", sortable: false },
        { key: "status", label: "Status", sortable: false },
        {
          key: "actions",
          label: "",
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      showAnidModal: false,
      anidModalMode: "create",
      anidForm: {
        id: null,
        admin_id: null,
        anid: "",
        label: "",
        is_active: true,
        shared_secret: "",
      },
      packageTypeMappings: [],
      showPackageTypeMappingModal: false,
      packageTypeMappingModalMode: "create",
      packageTypeMappingForm: {
        id: null,
        our_package_type: "",
        ariba_package_type: "",
      },
      sessions: [],
      orders: [],
      searchText: "",
      showCartModal: false,
      selectedSessionCart: [],
      selectedSessionTotal: 0,
      showOrderDetailsModal: false,
      selectedOrderItems: [],
      selectedOrderTotal: 0,
      selectedOrder: null,
      showExportModal: false,
      employees: [],
      employeeQuery: "",
      selectedEmployee: null,
      orderToExport: null,
      showSimulationModal: false,
      administrators: [],
      selectedSimulationAdmin: null,
      showImportModal: false,
      orderToImport: null,
      importEmployees: [],
      importEmployeeQuery: "",
      selectedImportEmployee: null,
    };
  },
  computed: {
    employeeList() {
      return this.employees;
    },
    packageTypeMappingModalTitle() {
      return this.packageTypeMappingModalMode === "edit"
        ? "Izmeni mapiranje"
        : "Dodaj mapiranje";
    },
    anidModalTitle() {
      return this.anidModalMode === "edit"
        ? "Izmeni Ariba nalog"
        : "Dodaj Ariba nalog";
    },
    administratorOptions() {
      return this.administrators.map((admin) => ({
        value: admin.id,
        text: admin.company_name,
      }));
    },
  },
  async created() {
    await this.loadSessions();
    await this.loadOrders();
    await this.loadPackageTypeMappings();
    await this.loadAdministrators();
    await this.loadAnids();
  },
  methods: {
    async loadAnids() {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get("/super-admin/ariba/anids");
        this.anids = Array.isArray(data) ? data : [];
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error fetching ariba anids:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    openCreateAnid() {
      this.$store.commit("errorBag/CLEAR");
      this.anidModalMode = "create";
      this.anidForm = {
        id: null,
        admin_id: null,
        anid: "",
        label: "",
        is_active: true,
        shared_secret: "",
      };
      this.showAnidModal = true;
    },
    openEditAnid(anid) {
      this.$store.commit("errorBag/CLEAR");
      this.anidModalMode = "edit";
      this.anidForm = {
        id: anid.id,
        admin_id: anid.admin_id,
        anid: anid.anid,
        label: anid.label || "",
        is_active: anid.is_active,
        // The secret is never returned by the API; leaving this empty keeps the
        // stored one untouched.
        shared_secret: "",
      };
      this.showAnidModal = true;
    },
    async saveAnid(bvModalEvt) {
      this.$store.commit("errorBag/CLEAR");
      if (bvModalEvt && typeof bvModalEvt.preventDefault === "function") {
        bvModalEvt.preventDefault();
      }

      const payload = {
        admin_id: this.anidForm.admin_id,
        anid: (this.anidForm.anid || "").toString().trim().toUpperCase(),
        label: (this.anidForm.label || "").toString().trim() || null,
        is_active: !!this.anidForm.is_active,
      };

      if (!payload.admin_id || !payload.anid) {
        toast("Izaberite firmu i unesite ANID.", variants.ERROR);
        return;
      }

      // Only send the secret when one was typed, so an edit does not wipe it.
      const secret = (this.anidForm.shared_secret || "").toString().trim();
      if (secret) {
        payload.shared_secret = secret;
      }

      this.$store.commit("loader/START_LOADING");
      try {
        if (this.anidModalMode === "edit") {
          await axios.put(`/super-admin/ariba/anids/${this.anidForm.id}`, payload);
          toast("Ariba nalog je uspešno izmenjen.", variants.SUCCESS);
        } else {
          await axios.post("/super-admin/ariba/anids", payload);
          toast("Ariba nalog je uspešno dodat.", variants.SUCCESS);
        }

        this.showAnidModal = false;
        await this.loadAnids();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error saving ariba anid:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async toggleAnidActive(anid) {
      const action = anid.is_active ? "Deaktivirati" : "Aktivirati";
      const consequence = anid.is_active
        ? "Porudžbine sa ovog naloga se više neće primati."
        : "Porudžbine sa ovog naloga će se ponovo primati.";

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `${action} nalog ${anid.anid}? ${consequence}`,
        {
          title: "Potvrda",
          okVariant: anid.is_active ? "danger" : "success",
          okTitle: anid.is_active ? "Deaktiviraj" : "Aktiviraj",
          cancelTitle: "Otkaži",
          cancelVariant: "secondary",
          centered: true,
        },
      );
      if (!confirmed) return;

      this.$store.commit("loader/START_LOADING");
      try {
        await axios.put(`/super-admin/ariba/anids/${anid.id}`, {
          is_active: !anid.is_active,
        });
        toast(
          anid.is_active ? "Nalog je deaktiviran." : "Nalog je aktiviran.",
          variants.SUCCESS,
        );
        await this.loadAnids();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error toggling ariba anid:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async deleteAnid(anid) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Obrisati nalog ${anid.anid}? Ako je u pitanju nalog koji se gasi posle migracije, bolje ga je deaktivirati nego obrisati.`,
        {
          title: "Potvrda brisanja",
          okVariant: "danger",
          okTitle: "Obriši",
          cancelTitle: "Otkaži",
          cancelVariant: "secondary",
          centered: true,
        },
      );
      if (!confirmed) return;

      this.$store.commit("loader/START_LOADING");
      try {
        await axios.delete(`/super-admin/ariba/anids/${anid.id}`);
        toast("Nalog je obrisan.", variants.SUCCESS);
        await this.loadAnids();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error deleting ariba anid:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async loadPackageTypeMappings() {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get("/super-admin/package-type-mappings");
        this.packageTypeMappings = Array.isArray(data) ? data : [];
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error fetching package type mappings:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    openCreatePackageTypeMapping() {
      this.$store.commit("errorBag/CLEAR");
      this.packageTypeMappingModalMode = "create";
      this.packageTypeMappingForm = {
        id: null,
        our_package_type: "",
        ariba_package_type: "",
      };
      this.showPackageTypeMappingModal = true;
    },
    openEditPackageTypeMapping(mapping) {
      this.$store.commit("errorBag/CLEAR");
      this.packageTypeMappingModalMode = "edit";
      this.packageTypeMappingForm = {
        id: mapping.id,
        our_package_type: mapping.our_package_type,
        ariba_package_type: mapping.ariba_package_type,
      };
      this.showPackageTypeMappingModal = true;
    },
    async savePackageTypeMapping(bvModalEvt) {
      this.$store.commit("errorBag/CLEAR");
      if (bvModalEvt && typeof bvModalEvt.preventDefault === "function") {
        bvModalEvt.preventDefault();
      }

      const payload = {
        our_package_type: (this.packageTypeMappingForm.our_package_type || "")
          .toString()
          .trim(),
        ariba_package_type: (
          this.packageTypeMappingForm.ariba_package_type || ""
        )
          .toString()
          .trim(),
      };

      if (!payload.our_package_type || !payload.ariba_package_type) {
        toast("Popunite oba polja.", variants.ERROR);
        return;
      }

      this.$store.commit("loader/START_LOADING");
      try {
        if (this.packageTypeMappingModalMode === "edit") {
          await axios.put(
            `/super-admin/package-type-mappings/${this.packageTypeMappingForm.id}`,
            payload,
          );
          toast("Mapiranje je uspešno izmenjeno.", variants.SUCCESS);
        } else {
          await axios.post("/super-admin/package-type-mappings", payload);
          toast("Mapiranje je uspešno dodato.", variants.SUCCESS);
        }

        this.showPackageTypeMappingModal = false;
        await this.loadPackageTypeMappings();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error saving package type mapping:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async deletePackageTypeMapping(mapping) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Obrisati mapiranje za "${mapping.our_package_type}"?`,
        {
          title: "Potvrda brisanja",
          okVariant: "danger",
          okTitle: "Obriši",
          cancelTitle: "Otkaži",
          cancelVariant: "secondary",
          centered: true,
        },
      );
      if (!confirmed) return;

      this.$store.commit("loader/START_LOADING");
      try {
        await axios.delete(`/super-admin/package-type-mappings/${mapping.id}`);
        toast("Mapiranje je obrisano.", variants.SUCCESS);
        await this.loadPackageTypeMappings();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Error deleting package type mapping:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async loadSessions() {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get("/super-admin/ariba/sessions");
        // Convert object with numeric keys to array
        const sessionsArray = Array.isArray(data) ? data : Object.values(data);
        this.sessions = sessionsArray.map((session) => ({
          ...session,
          statusLabel: this.getStatusLabel(session.status),
        }));
      } catch (e) {
        console.error("Error fetching sessions:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async loadOrders() {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get("/super-admin/ariba/orders");
        this.orders = data;
      } catch (e) {
        console.error("Error fetching orders:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async loadEmployees(orderId) {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get(
          `/super-admin/ariba/orders/${orderId}/employees`,
        );
        this.employees = data;
      } catch (e) {
        console.error("Error fetching employees:", e);
        this.employees = [];
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    viewCart(session) {
      this.selectedSessionCart = session.cart;
      this.selectedSessionTotal = session.cart.reduce(
        (sum, item) => sum + (item.total || item.price * item.amount),
        0,
      );
      this.showCartModal = true;
    },
    async setupMock() {
      if (!this.selectedSimulationAdmin) {
        toast("Izaberite firmu.", variants.ERROR);
        return;
      }
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.post(
          `/super-admin/ariba/admins/${this.selectedSimulationAdmin.id}/setup-mock`,
        );
        if (data.shop_url) {
          window.open(data.shop_url, "_blank");
        }
        this.showSimulationModal = false;
        this.selectedSimulationAdmin = null;
      } catch (e) {
        console.error("Error setting up mock:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    openSimulationModal() {
      this.selectedSimulationAdmin = null;
      this.showSimulationModal = true;
    },
    async loadAdministrators() {
      try {
        const { data } = await axios.get("/super-admin/administrators");
        this.administrators = data.filter((admin) => admin.is_ariba_enabled);
      } catch (e) {
        console.error("Error loading administrators:", e);
      }
    },
    async viewOrder(order) {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get(
          `/super-admin/ariba/orders/${order.id}`,
        );
        this.selectedOrder = data;
        this.selectedOrderItems = data.items || [];
        this.selectedOrderTotal = (this.selectedOrderItems || []).reduce(
          (sum, item) => sum + item.unit_price * item.quantity,
          0,
        );
        this.showOrderDetailsModal = true;
      } catch (e) {
        console.error("Error fetching order details:", e);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async deleteOrder(order) {
      this.$store.commit("loader/START_LOADING");
      try {
        await axios.delete(`/super-admin/ariba/orders/${order.id}`);
        toast("Porudžbina je obrisana.", variants.SUCCESS);

        if (this.selectedOrder && this.selectedOrder.id === order.id) {
          this.showOrderDetailsModal = false;
          this.selectedOrder = null;
          this.selectedOrderItems = [];
          this.selectedOrderTotal = 0;
        }

        if (this.orderToExport && this.orderToExport.id === order.id) {
          this.showExportModal = false;
          this.orderToExport = null;
          this.selectedEmployee = null;
          this.employeeQuery = "";
        }

        await this.loadOrders();
      } catch (e) {
        console.error("Error deleting order:", e);
        toast("Greška pri brisanju porudžbine.", variants.ERROR);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    getStatusBadge(status) {
      const statusMap = {
        active: "success",
        expired: "danger",
        completed: "info",
      };
      return statusMap[status] || "secondary";
    },
    getStatusLabel(status) {
      const statusMap = {
        active: "Aktivna",
        expired: "Istekla",
        completed: "Završena",
      };
      return statusMap[status] || status;
    },
    formatDate(date) {
      return new Date(date).toLocaleString("sr-RS");
    },
    formatCurrency(amount) {
      if (!amount) return "0.00";
      return parseFloat(amount).toFixed(2);
    },
    onEmployeeSelect(employee) {
      if (!employee.disabled) {
        this.selectedEmployee = employee;
      }
    },
    downloadOrderPdf() {
      if (!this.selectedOrder) return;

      const order = this.selectedOrder;
      const items = this.selectedOrderItems;
      const total = this.selectedOrderTotal;
      const currency = order.currency || "RSD";

      let itemRows = "";
      for (const item of items) {
        itemRows += `<tr>
          <td>${item.line_number}</td>
          <td>${item.supplier_part_id}</td>
          <td>${item.description || "-"}</td>
          <td>${parseFloat(item.quantity).toFixed(2)}</td>
          <td>${item.unit_of_measure || "-"}</td>
          <td>${parseFloat(item.unit_price).toFixed(2)}</td>
          <td>${(item.unit_price * item.quantity).toFixed(2)}</td>
        </tr>`;
      }

      const comments = order.comments || "";
      const commentsHtml = comments
        ? `<div class="section"><p><strong>Napomena:</strong> ${comments.replace(
            /\n/g,
            "<br>",
          )}</p></div>`
        : "";

      // Ship-to address block
      let shipToHtml = "";
      if (order.ship_to_name) {
        shipToHtml = `<div class="addr-block">
          <div class="addr-label">Adresa isporuke</div>
          <strong>${order.ship_to_name}</strong><br>
          ${order.ship_to_street ? order.ship_to_street + "<br>" : ""}
          ${order.ship_to_postal_code || ""} ${order.ship_to_city || ""}${
          order.ship_to_postal_code || order.ship_to_city ? "<br>" : ""
        }
          ${order.ship_to_country || ""}
        </div>`;
      }

      // Bill-to address block
      let billToHtml = "";
      if (order.bill_to_name) {
        billToHtml = `<div class="addr-block">
          <div class="addr-label">Adresa plaćanja</div>
          <strong>${order.bill_to_name}</strong><br>
          ${order.bill_to_street ? order.bill_to_street + "<br>" : ""}
          ${order.bill_to_postal_code || ""} ${order.bill_to_city || ""}${
          order.bill_to_postal_code || order.bill_to_city ? "<br>" : ""
        }
          ${order.bill_to_country || ""}
        </div>`;
      }

      // Requester block
      const requesterName = order.requester_name || order.deliver_to || "";
      const requesterEmail = order.requester_email || order.ship_to_email || "";
      let requesterHtml = "";
      if (requesterName || requesterEmail) {
        requesterHtml = `<div class="addr-block">
          <div class="addr-label">Zahtev poslao</div>
          ${
            requesterName
              ? "<strong>Ime:</strong> " + requesterName + "<br>"
              : ""
          }
          ${requesterEmail ? "<strong>Email:</strong> " + requesterEmail : ""}
        </div>`;
      }

      const hasAddressInfo = shipToHtml || billToHtml || requesterHtml;
      const addressSectionHtml = hasAddressInfo
        ? `<div class="section"><h3>Dodatne informacije</h3><div class="address-row">${shipToHtml}${billToHtml}${requesterHtml}</div></div>`
        : "";

      const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${order.order_id}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
    h2 { margin-bottom: 10px; }
    h3 { font-size: 13px; margin: 0 0 8px 0; }
    .info { margin-bottom: 15px; }
    .info p { margin: 2px 0; }
    .info-row { display: flex; gap: 40px; }
    .info-col { flex: 1; }
    .section { margin-bottom: 15px; }
    .address-row { display: flex; gap: 30px; }
    .addr-block { flex: 1; }
    .addr-label { color: #666; margin-bottom: 4px; font-size: 11px; }
    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
    th, td { border: 1px solid #ccc; padding: 6px 8px; text-align: left; }
    th { background-color: #f0f0f0; }
    .total { margin-top: 15px; font-size: 14px; font-weight: bold; }
    @media print { body { margin: 0; } }
  </style>
</head>
<body>
  <h2>Porudžbina: ${order.order_id}</h2>
  <div class="info">
    <div class="info-row">
      <div class="info-col">
        <p><strong>Datum:</strong> ${new Date(order.order_date).toLocaleString(
          "sr-RS",
        )}</p>
        <p><strong>Valuta:</strong> ${currency}</p>
      </div>
      <div class="info-col">
        <p><strong>Ukupan iznos:</strong> ${parseFloat(
          order.total_amount,
        ).toFixed(2)} ${currency}</p>
      </div>
    </div>
  </div>
  ${addressSectionHtml}
  ${commentsHtml}
  <table>
    <thead>
      <tr>
        <th>Redni broj</th>
        <th>Šifra artikla</th>
        <th>Opis</th>
        <th>Količina</th>
        <th>Jed. mere</th>
        <th>Cena</th>
        <th>Ukupno</th>
      </tr>
    </thead>
    <tbody>${itemRows}</tbody>
  </table>
  <div class="total">Ukupno: ${parseFloat(total).toFixed(2)} ${currency}</div>
</body>
</html>`;

      const printWindow = window.open("", "_blank");
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.onload = function() {
        printWindow.print();
      };
    },
    async openExportModal(order) {
      this.orderToExport = order;
      this.selectedEmployee = null;
      this.employeeQuery = "";
      this.employees = [];
      this.showExportModal = true;
      await this.loadEmployees(order.id);
    },
    async confirmExport() {
      if (!this.selectedEmployee || !this.orderToExport) return;

      this.$store.commit("loader/START_LOADING");
      try {
        const response = await axios.get(
          `/super-admin/ariba/orders/${this.orderToExport.id}/export/${this.selectedEmployee.id}`,
          {
            responseType: "blob",
          },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `porudzbina-${this.orderToExport.order_id}-${this.selectedEmployee.object_name}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast("Porudžbina je uspešno preuzeta.", variants.SUCCESS);
        this.showExportModal = false;
      } catch (e) {
        console.error("Error exporting order:", e);
        toast("Greška pri preuzimanju porudžbine.", variants.ERROR);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async openImportModal(order) {
      this.orderToImport = order;
      this.selectedImportEmployee = null;
      this.importEmployeeQuery = "";
      this.importEmployees = [];
      this.showImportModal = true;
      await this.loadImportEmployees(order.id);
    },
    async loadImportEmployees(orderId) {
      this.$store.commit("loader/START_LOADING");
      try {
        const { data } = await axios.get(
          `/super-admin/ariba/orders/${orderId}/employees`,
        );
        this.importEmployees = data;
      } catch (e) {
        console.error("Error fetching employees for import:", e);
        this.importEmployees = [];
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    onImportEmployeeSelect(employee) {
      if (!employee.disabled) {
        this.selectedImportEmployee = employee;
      }
    },
    async confirmImport() {
      if (!this.selectedImportEmployee || !this.orderToImport) return;

      this.$store.commit("loader/START_LOADING");
      try {
        await axios.put(
          `/super-admin/ariba/orders/${this.orderToImport.id}/import/${this.selectedImportEmployee.id}`,
        );
        toast("Porudžbina je uspešno poslata u APP.", variants.SUCCESS);
        this.showImportModal = false;
        this.orderToImport = null;
        this.selectedImportEmployee = null;
        this.importEmployeeQuery = "";
      } catch (e) {
        console.error("Error importing order:", e);
        const errorMessage =
          e.response?.data?.message || "Greška pri slanju porudžbine u APP.";
        toast(errorMessage, variants.ERROR);
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row mb-2 mb-3">
      <div
        class="col-12 col-md-12 d-flex align-items-end justify-content-end gap-2"
      >
        <b-button @click="openSimulationModal" variant="primary">
          Pokreni simulaciju
        </b-button>
      </div>
    </div>

    <b-tabs v-model="activeTab" class="mb-3">
      <!-- Orders Tab -->
      <b-tab title="Porudžbine" :title-link-class="'font-weight-bold'">
        <div class="card mt-3">
          <div class="card-body">
            <b-table
              :items="orders"
              :fields="orderFields"
              striped
              responsive
              class="border-left border-right border-bottom"
            >
              <template v-slot:cell(order_date)="data">
                {{ formatDate(data.item.order_date) }}
              </template>
              <template v-slot:cell(connection)="data">
                <div>
                  <b-badge
                    v-if="
                      data.item.ariba_anid &&
                      data.item.ariba_anid.is_test_account
                    "
                    variant="warning"
                    class="mr-1"
                  >
                    TEST
                  </b-badge>
                  <span>{{
                    (data.item.ariba_anid && data.item.ariba_anid.label) ||
                    data.item.buyer_network_id ||
                    "—"
                  }}</span>
                </div>
                <small class="text-muted">{{
                  data.item.buyer_network_id
                }}</small>
              </template>
              <template v-slot:cell(total_amount)="data">
                {{ formatCurrency(data.item.total_amount) }}
                {{ data.item.currency || "RSD" }}
              </template>
              <template v-slot:cell(actions)="data">
                <div class="text-right">
                  <b-button
                    size="sm"
                    variant="info"
                    class="mr-2"
                    @click="viewOrder(data.item)"
                  >
                    Prikazi stavke
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-2"
                    @click="openExportModal(data.item)"
                  >
                    <i class="mdi mdi-file-export mr-1"></i>
                    Preuzmi
                  </b-button>
                  <b-button
                    size="sm"
                    variant="success"
                    class="mr-2"
                    @click="openImportModal(data.item)"
                  >
                    <i class="mdi mdi-upload mr-1"></i>
                    Pošalji u APP
                  </b-button>
                  <confirmation-modal
                    buttonClass=""
                    variant="danger"
                    size="sm"
                    :message="
                      `Da li ste sigurni da želite da obrišete porudžbinu: ${data.item.order_id}?`
                    "
                    title="Izbriši porudžbinu"
                    buttonText="Obriši"
                    @onSubmit="deleteOrder(data.item)"
                  />
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </b-tab>

      <!-- Sessions Tab -->
      <b-tab title="Ariba Sesije" :title-link-class="'font-weight-bold'">
        <div class="card">
          <div class="card-body">
            <b-table
              :items="sessions"
              :fields="sessionFields"
              striped
              responsive
              class="border-left border-right border-bottom"
            >
              <template v-slot:cell(created_at)="data">
                {{ formatDate(data.item.created_at) }}
              </template>
              <template v-slot:cell(actions)="data">
                <div class="text-right">
                  <b-button
                    size="sm"
                    variant="info"
                    @click.stop="viewCart(data.item)"
                  >
                    Prikazi
                  </b-button>
                </div>
              </template>
              <template v-slot:cell(statusLabel)="data">
                <span>
                  {{ data.item.statusLabel }}
                </span>
              </template>
            </b-table>
          </div>
        </div>
      </b-tab>

      <!-- Units of measurement tab -->
      <b-tab title="Merne jedinice" :title-link-class="'font-weight-bold'">
        <div class="row mb-3">
          <div class="col-12 d-flex align-items-center justify-content-between">
            <div class="text-muted">
              Mapiranje mernih jedinica (BIGZ → Ariba).
            </div>
            <b-button
              variant="primary"
              class="mt-2"
              @click="openCreatePackageTypeMapping"
            >
              Dodaj mapiranje
            </b-button>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <b-table
              :items="packageTypeMappings"
              :fields="packageTypeMappingFields"
              striped
              responsive
              class="border-left border-right border-bottom"
            >
              <template v-slot:cell(actions)="data">
                <div class="text-right">
                  <b-button
                    size="sm"
                    variant="outline-warning"
                    class="mr-2"
                    @click="openEditPackageTypeMapping(data.item)"
                  >
                    Izmeni
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="deletePackageTypeMapping(data.item)"
                  >
                    Obriši
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </b-tab>

      <b-tab title="Ariba nalozi" :title-link-class="'font-weight-bold'">
        <div class="row mb-3">
          <div class="col-12 d-flex align-items-center justify-content-between">
            <div class="text-muted">
              Ariba nalozi (ANID) preko kojih kupci šalju porudžbine. Jedan kupac
              može imati više naloga istovremeno — npr. tokom prelaska na novu
              Ariba instancu. Neaktivni nalozi se odbijaju.
            </div>
            <b-button variant="primary" class="mt-2" @click="openCreateAnid">
              Dodaj nalog
            </b-button>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <b-table
              :items="anids"
              :fields="anidFields"
              striped
              responsive
              class="border-left border-right border-bottom"
            >
              <template v-slot:cell(anid)="data">
                <code>{{ data.item.anid }}</code>
              </template>

              <template v-slot:cell(label)="data">
                {{ data.item.label || "—" }}
              </template>

              <template v-slot:cell(type)="data">
                <b-badge
                  :variant="data.item.is_test_account ? 'warning' : 'info'"
                >
                  {{ data.item.is_test_account ? "TEST" : "PRODUKCIJA" }}
                </b-badge>
              </template>

              <template v-slot:cell(secret)="data">
                <span
                  :class="
                    data.item.has_own_shared_secret
                      ? 'text-body'
                      : 'text-muted font-italic'
                  "
                >
                  {{
                    data.item.has_own_shared_secret
                      ? "Sopstvena"
                      : "Podrazumevana"
                  }}
                </span>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge :variant="data.item.is_active ? 'success' : 'secondary'">
                  {{ data.item.is_active ? "Aktivan" : "Neaktivan" }}
                </b-badge>
              </template>

              <template v-slot:cell(actions)="data">
                <div class="text-right">
                  <b-button
                    size="sm"
                    :variant="
                      data.item.is_active
                        ? 'outline-secondary'
                        : 'outline-success'
                    "
                    class="mr-2"
                    @click="toggleAnidActive(data.item)"
                  >
                    {{ data.item.is_active ? "Deaktiviraj" : "Aktiviraj" }}
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-warning"
                    class="mr-2"
                    @click="openEditAnid(data.item)"
                  >
                    Izmeni
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="deleteAnid(data.item)"
                  >
                    Obriši
                  </b-button>
                </div>
              </template>
            </b-table>

            <div v-if="anids.length === 0" class="text-muted text-center py-3">
              Nema unetih Ariba naloga.
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <!-- Cart Modal (Sessions) -->
    <b-modal
      v-model="showCartModal"
      title="Artikli iz korpe"
      size="lg"
      centered
      hide-footer
    >
      <div v-if="selectedSessionCart.length > 0">
        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Naziv</th>
                <th>Cena (RSD)</th>
                <th>Količina</th>
                <th>Ukupno (RSD)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in selectedSessionCart" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.price }}</td>
                <td>{{ item.amount }}</td>
                <td>
                  {{ item.total || (item.price * item.amount).toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3 border-top pt-3">
          <h5>
            Ukupno: <strong>{{ selectedSessionTotal.toFixed(2) }} RSD</strong>
          </h5>
        </div>
      </div>
      <div v-else class="text-center text-muted">
        Korpa je prazna
      </div>
    </b-modal>

    <!-- Order Details Modal -->
    <b-modal
      v-model="showOrderDetailsModal"
      title="Stavke porudžbine"
      size="lg"
      dialog-class="order-details-modal"
      centered
      hide-footer
    >
      <div v-if="selectedOrder" class="order-details">
        <div class="mb-3">
          <h6 class="font-weight-bold">Informacije o porudžbini</h6>
          <div class="row">
            <div class="col-md-6">
              <p>
                <strong>Broj porudžbine:</strong> {{ selectedOrder.order_id }}
              </p>
              <p>
                <strong>Datum:</strong>
                {{ formatDate(selectedOrder.order_date) }}
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <strong>Valuta:</strong> {{ selectedOrder.currency || "RSD" }}
              </p>
              <p>
                <strong>Ukupan iznos:</strong>
                {{ formatCurrency(selectedOrder.total_amount) }}
              </p>
              <p>
                <strong>Okruženje:</strong>
                {{ selectedOrder.deployment_mode || "-" }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="mb-3"
          v-if="
            selectedOrder.ship_to_name ||
              selectedOrder.bill_to_name ||
              selectedOrder.requester_name ||
              selectedOrder.requester_email ||
              selectedOrder.ship_to_email ||
              selectedOrder.deliver_to
          "
        >
          <h6 class="font-weight-bold">Dodatne informacije</h6>
          <div class="row">
            <div class="col-md-4" v-if="selectedOrder.ship_to_name">
              <div class="text-muted mb-1">Adresa isporuke</div>
              <div>
                <strong>{{ selectedOrder.ship_to_name }}</strong
                ><br />
                <span v-if="selectedOrder.ship_to_street">
                  {{ selectedOrder.ship_to_street }}<br />
                </span>
                <span
                  v-if="
                    selectedOrder.ship_to_postal_code ||
                      selectedOrder.ship_to_city
                  "
                >
                  {{ selectedOrder.ship_to_postal_code || "" }}
                  {{ selectedOrder.ship_to_city || "" }}<br />
                </span>
                <span v-if="selectedOrder.ship_to_country">
                  {{ selectedOrder.ship_to_country }}
                </span>
              </div>
            </div>

            <div class="col-md-4" v-if="selectedOrder.bill_to_name">
              <div class="text-muted mb-1">Adresa plaćanja</div>
              <div>
                <strong>{{ selectedOrder.bill_to_name }}</strong
                ><br />
                <span v-if="selectedOrder.bill_to_street">
                  {{ selectedOrder.bill_to_street }}<br />
                </span>
                <span
                  v-if="
                    selectedOrder.bill_to_postal_code ||
                      selectedOrder.bill_to_city
                  "
                >
                  {{ selectedOrder.bill_to_postal_code || "" }}
                  {{ selectedOrder.bill_to_city || "" }}<br />
                </span>
                <span v-if="selectedOrder.bill_to_country">
                  {{ selectedOrder.bill_to_country }}
                </span>
              </div>
            </div>

            <div
              class="col-md-4"
              v-if="
                selectedOrder.requester_name ||
                  selectedOrder.requester_email ||
                  selectedOrder.deliver_to ||
                  selectedOrder.ship_to_email
              "
            >
              <div class="text-muted mb-1">Zahtev poslao</div>
              <div>
                <div>
                  <strong>Ime:</strong>
                  {{
                    selectedOrder.requester_name ||
                      selectedOrder.deliver_to ||
                      "-"
                  }}
                </div>
                <div class="text-break">
                  <strong>Email:</strong>
                  {{
                    selectedOrder.requester_email ||
                      selectedOrder.ship_to_email ||
                      "-"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedOrder.comments" class="mb-3">
          <h6 class="font-weight-bold">Napomena</h6>
          <p class="mb-0" style="white-space: pre-line;">
            {{ selectedOrder.comments }}
          </p>
        </div>

        <div class="border-top pt-3">
          <h6 class="font-weight-bold mb-3">Stavke porudžbine</h6>
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Redni broj</th>
                  <th>Šifra artikla</th>
                  <th>Opis</th>
                  <th>Količina</th>
                  <th>Jed. mere</th>
                  <th>Cena</th>
                  <th>Ukupno</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in selectedOrderItems" :key="item.id">
                  <td>{{ item.line_number }}</td>
                  <td>{{ item.supplier_part_id }}</td>
                  <td>{{ item.description || "-" }}</td>
                  <td>{{ formatCurrency(item.quantity) }}</td>
                  <td>{{ item.unit_of_measure || "-" }}</td>
                  <td>{{ formatCurrency(item.unit_price) }}</td>
                  <td>{{ formatCurrency(item.unit_price * item.quantity) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="mt-3 border-top pt-3 d-flex align-items-center justify-content-between"
        >
          <h5 class="mb-0">
            Ukupno:
            <strong
              >{{ formatCurrency(selectedOrderTotal) }}
              {{ selectedOrder.currency || "RSD" }}</strong
            >
          </h5>
          <b-button
            variant="outline-primary"
            size="sm"
            @click="downloadOrderPdf"
          >
            <i class="mdi mdi-file-pdf-box mr-1"></i>
            Preuzmi PDF
          </b-button>
        </div>
      </div>
      <div v-else class="text-center text-muted">
        Učitavanje...
      </div>
    </b-modal>

    <!-- Export Modal -->
    <b-modal
      v-model="showExportModal"
      title="Preuzmi porudžbinu"
      size="lg"
      centered
      @ok="confirmExport"
      ok-only
      :ok-disabled="!selectedEmployee"
      ok-title="Preuzmi"
    >
      <div v-if="orderToExport" class="mb-3">
        <p><strong>Broj porudžbine:</strong> {{ orderToExport.order_id }}</p>
      </div>
      <div class="form-group">
        <label for="employee-select">Odaberite objekat:</label>
        <div v-if="employees.length === 0" class="alert alert-info mb-0">
          Nema dostupnih objekata
        </div>
        <VueBootstrapAutocomplete
          v-else
          class="autocomplete"
          id="employee-select"
          v-model="employeeQuery"
          :data="employeeList"
          :serializer="(item) => item.object_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="onEmployeeSelect($event)"
        />
      </div>
      <div v-if="selectedEmployee" class="alert alert-info">
        <strong>Odabrano:</strong> {{ selectedEmployee.object_name }}
      </div>
    </b-modal>

    <!-- Ariba ANID modal -->
    <b-modal
      v-model="showAnidModal"
      :title="anidModalTitle"
      centered
      @ok="saveAnid"
      ok-title="Sačuvaj"
      cancel-title="Otkaži"
    >
      <ErrorAlert></ErrorAlert>
      <div class="form-group">
        <label for="anid-admin">Firma</label>
        <b-form-select
          id="anid-admin"
          v-model="anidForm.admin_id"
          :options="administratorOptions"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled>
              Izaberite firmu
            </b-form-select-option>
          </template>
        </b-form-select>
        <small class="text-muted" v-if="administrators.length === 0">
          Nema firmi sa omogućenom Aribom.
        </small>
      </div>

      <div class="form-group">
        <label for="anid-value">ANID</label>
        <b-form-input
          id="anid-value"
          v-model="anidForm.anid"
          placeholder="npr. AN11239752264"
        />
        <small class="text-muted">
          Test nalozi se završavaju sa "-T". Jedan ANID može pripadati samo
          jednoj firmi.
        </small>
      </div>

      <div class="form-group">
        <label for="anid-label">Naziv</label>
        <b-form-input
          id="anid-label"
          v-model="anidForm.label"
          placeholder="npr. Fresenius - nova instanca"
        />
        <small class="text-muted">
          Prikazuje se uz porudžbine da bi se znalo sa kog naloga su stigle.
        </small>
      </div>

      <div class="form-group">
        <label for="anid-secret">Lozinka (SharedSecret)</label>
        <b-form-input
          id="anid-secret"
          v-model="anidForm.shared_secret"
          type="password"
          autocomplete="new-password"
          :placeholder="
            anidModalMode === 'edit'
              ? 'Ostavite prazno da se ne menja'
              : 'Ostavite prazno za podrazumevanu'
          "
        />
        <small class="text-muted">
          Ako kupac koristi posebnu lozinku za ovaj nalog, unesite je ovde. U
          suprotnom se koristi podrazumevana.
        </small>
      </div>

      <div class="form-group mb-0">
        <b-form-checkbox v-model="anidForm.is_active" switch>
          Aktivan — prima porudžbine
        </b-form-checkbox>
      </div>
    </b-modal>

    <!-- Package type mapping modal -->
    <b-modal
      v-model="showPackageTypeMappingModal"
      :title="packageTypeMappingModalTitle"
      centered
      @ok="savePackageTypeMapping"
      ok-title="Sačuvaj"
      cancel-title="Otkaži"
    >
      <ErrorAlert></ErrorAlert>
      <div class="form-group">
        <label for="our-package-type">Merna jedinica (BIGZ)</label>
        <b-form-input
          id="our-package-type"
          v-model="packageTypeMappingForm.our_package_type"
          placeholder="npr. KOM, PAK, KG..."
        />
        <small class="text-muted">Vrednost mora biti jedinstvena.</small>
      </div>

      <div class="form-group">
        <label for="ariba-package-type">Merna jedinica (Ariba)</label>
        <b-form-input
          id="ariba-package-type"
          v-model="packageTypeMappingForm.ariba_package_type"
          placeholder="npr. EA, BX, PK..."
        />
      </div>
    </b-modal>

    <!-- Import Modal -->
    <b-modal
      v-model="showImportModal"
      title="Pošalji porudžbinu u APP"
      size="lg"
      centered
      @ok="confirmImport"
      ok-only
      :ok-disabled="!selectedImportEmployee"
      ok-title="Pošalji"
    >
      <div v-if="orderToImport" class="mb-3">
        <p><strong>Broj porudžbine:</strong> {{ orderToImport.order_id }}</p>
      </div>
      <div class="form-group">
        <label for="import-employee-select">Odaberite objekat:</label>
        <div v-if="importEmployees.length === 0" class="alert alert-info mb-0">
          Nema dostupnih objekata
        </div>
        <VueBootstrapAutocomplete
          v-else
          class="autocomplete"
          id="import-employee-select"
          v-model="importEmployeeQuery"
          :data="importEmployees"
          :serializer="(item) => item.object_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="onImportEmployeeSelect($event)"
        />
      </div>
      <div v-if="selectedImportEmployee" class="alert alert-info">
        <strong>Odabrano:</strong> {{ selectedImportEmployee.object_name }}
      </div>
    </b-modal>

    <!-- Simulation Modal -->
    <b-modal
      v-model="showSimulationModal"
      title="Pokreni simulaciju"
      ok-title="Pokreni"
      cancel-title="Otkaži"
      @ok="setupMock"
    >
      <div class="form-group">
        <label for="simulation-admin">Izaberite firmu</label>
        <VueBootstrapAutocomplete
          id="simulation-admin"
          :data="administrators"
          :serializer="(item) => item.company_name"
          :minMatchingChars="0"
          showOnFocus
          placeholder="Pretraži firme..."
          @hit="selectedSimulationAdmin = $event"
        />
        <small class="text-muted" v-if="administrators.length === 0">
          Nema firmi sa omogućenom Ariba integracijom.
        </small>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.search-box .form-control {
  border-radius: 0.25rem;
}

::v-deep .table td {
  vertical-align: middle;
}

::v-deep .badge {
  font-size: 0.9rem;
  padding: 0.5rem 0.75rem;
}

/* Make the order details modal a bit wider and prevent long strings (emails/URLs) from overflowing */
::v-deep .order-details-modal {
  max-width: 1500px;
}

::v-deep .order-details-modal .modal-body {
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
